import { ANY_OPTION } from 'constants/selectOptions'

export const withShowAllOptions = isShowAllOption => options =>
  isShowAllOption ? [ANY_OPTION, ...options] : options
